/**
 * 要求・why・実装・監査（F7）の oRPC contract。今は監査 2 本だけを持つ。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 監査 2 本（実装カバレッジ・宙吊り参照）の procedure と、その専用エラーコードを oRPC contract として定義する。
 * @graph-connects none
 */
import { oc } from '@orpc/contract';
import { GetDanglingReferencesInputSchema, GetDanglingReferencesOutputSchema, GetImplementationCoverageInputSchema, GetImplementationCoverageOutputSchema, } from '../spec-graph-audit.js';
import { SHARED_ERRORS } from './common.js';
/**
 * 監査 2 本だけが返しうる「照合先が未接続」のエラーコード。
 *
 * 監査は仕様グラフ単独では答えを出せない。実装カバレッジも宙吊り参照も、SPG 索引
 * （実装レポの境界カタログ）との突合が答えの一部だからである。突合先が配線されていない
 * 供給元では、**空の残 TODO 一覧を返してはならない** — 監査の 0 件は「残作業なし」という
 * 一等地の答え（決定 ab）なので、未接続を 0 件で表すと嘘の完成報告になる。
 *
 * 空応答でも `INTERNAL_SERVER_ERROR` でもなく専用コードにするのは、UI が「壊れている」
 * ではなく「この供給元ではまだ見られない」と描き分けられるようにするためである。
 * @graph-connects none
 */
export const SPEC_GRAPH_AUDIT_NOT_CONNECTED = 'SPEC_GRAPH_AUDIT_NOT_CONNECTED';
/**
 * 監査 2 本の contract builder。共有エラーに未接続コードを 1 つ足しただけである。
 * @graph-connects none
 */
const auditBase = oc.errors({
    ...SHARED_ERRORS,
    [SPEC_GRAPH_AUDIT_NOT_CONNECTED]: {
        status: 503,
        message: '監査の照合先（SPG 索引）が接続されていないため、残 TODO を答えられません',
    },
});
/**
 * 監査の読取 procedure（`specGraph` に載る）。
 * @graph-connects none
 */
export const auditContract = {
    getImplementationCoverage: auditBase
        .input(GetImplementationCoverageInputSchema)
        .output(GetImplementationCoverageOutputSchema),
    getDanglingReferences: auditBase
        .input(GetDanglingReferencesInputSchema)
        .output(GetDanglingReferencesOutputSchema),
};
//# sourceMappingURL=requirements.js.map